<div class="animated fadeIn fast">
  <app-alert *ngIf="error" [alert]="error"></app-alert>
  <app-loading *ngIf="loading"></app-loading>
  <form [formGroup]="form" *ngIf="!loading" [class.mt-10]="error" appBlockCopyPaste>
    <div class="row row-check text-center">
      <p class="col-md-12 ta-initial">
        Ahora hemos enviado un sms con un código de acceso a su teléfono
        <b class="primary">{{ (getPhoneX())  }}</b>, por favor ingreselo para confirmar
        su identidad
      </p>
    </div>
    <div *ngIf="!loading"  class="row text-center">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <div class="form-group" [class.has-error]="helpers.invalidControl(form.get('code'))">
          <label for="code" class="label-form label-create-form label-password"
            >Ingresar código</label
          >
          <input
            type="text"
            formControlName="code"
            class="form-control"
            maxlength="6"
            mask="000000"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('code'))"
          >
            <span class="d-flex" *ngIf="form.get('code').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span
              class="d-flex"
              *ngIf="
                form.get('code').errors.minlength &&
                !form.get('code').errors.pattern
              "
              >{{ constants.validations.minDigits.message }}</span
            >
          </span>
          
        </div>
        <span class="help-block text-left">
          {{ textInfo }}
        </span>
        <a *ngIf="!error?.blocked" (click)="generateToken()" class="primary pointer"><b>Reenviar código de acceso ></b></a>
        <br><br>
        
      </div>
      
      <div class="col-md-2"></div>
    </div>
    <div *ngIf="!loading"  class="row text-center">
      <button
        [disabled]="form.invalid && !error?.blocked"
        (click)="error?.blocked ? backToLogin() : continue()"
        class="button-continue button-find-label"
      >
        {{ error?.blocked ? 'Ir al Login' : 'Continuar' }}
      </button>
    </div>
  </form>
</div>
